<template>

  <v-autocomplete v-model="competitionID"
                  label="Competition"
                  :placeholder="placeholder"
                  :items="competitions"
                  item-text="name"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"
                  :search-input.sync="textInput">
    <template slot="item" slot-scope="{ item }">
      <v-list-tile-content>
        <p class="item-text">
          {{ item.name }} - <b class="item-text-small">{{ item.regionAlias || 'Unknown region' }} - {{ item.federationID || 'Unknown federation' }}</b>
        </p>
      </v-list-tile-content>
    </template>
  </v-autocomplete>

</template>

<script>

export default {
  name: 'CompetitionSelector',
  props: [
    'federationID',
    'currentCompetitionID',
    'disabled',
    'disabledText'
  ],
  data () {
    return {
      loading: false,
      competitions: [],
      competitionID: '',

      textInput: '',

      preventNextSearch: false
    }
  },
  mounted () {
    if (this.currentCompetitionID) {
      this.setCurrentCompetition()
    }
  },
  methods: {
    handleInput (input) {
      this.loading = false
      this.textInput = input
      setTimeout(() => {
        if (input && (this.textInput === input)) {
          this.loading = true
          this.loadCompetitions()
        }
      }, 400)
    },
    setCurrentCompetition () {
      this.loading = true
      this.$store.dispatch('getCompetition', this.currentCompetitionID)
        .then(resp => {
          this.preventNextSearch = true
          this.competitions = [resp]
          this.competitionID = this.currentCompetitionID
          this.loading = false
        })
        .catch(() => {
          console.error('Error getting competition')
          this.loading = false
        })
    },
    loadCompetitions () {
      if (this.preventNextSearch) {
        this.loading = false
        this.preventNextSearch = false
        return
      }

      let params = {
        name: this.textInput
      }
      if (this.federationID) {
        params.federationID = this.federationID
      }

      this.$store.dispatch('searchCompetitions', params)
        .then(resp => {
          this.competitions = resp.items
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading competitions')
          this.loading = false
        })
    },
    clear () {
      this.competitionID = ''
      this.competitions = []
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || false
    },
    placeholder () {
      return this.isDisabled ? (this.disabledText || '') : 'Competition'
    }
  },
  watch: {
    'textInput' () {
      if (this.textInput) {
        this.handleInput(this.textInput)
      } else {
        this.competitions = []
      }
    },
    'federationID' () {
      this.clear()
    },
    'competitionID' () {
      this.$emit('competitionSelected', this.competitionID || '')
    },
    'currentCompetitionID' () {
      if (this.currentCompetitionID) {
        this.setCurrentCompetition()
      } else {
        this.clear()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .item-text {
    font-size: 13px;
  }

  .item-text-small {
    font-size: 11px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/CompetitionSelector.vue